import {NuxtIcon} from "#components";
import {h} from "vue";
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "svg-VF-logo_svg__Layer_2",
  "data-name": "Layer 2",
  viewBox: "0 0 140.27 50.01"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".svg-VF-logo_svg__cls-1{fill:#002554}.svg-VF-logo_svg__cls-2{fill:#008fda}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("g", {
      id: "svg-VF-logo_svg__Layer_1-2",
      "data-name": "Layer 1-2"
    }, [
      _createElementVNode("path", {
        d: "M72.55 8.4s-6.24 0-6.24 6.01v20.26c0 2.17-.28 3.91-.82 5.18-.54 1.25-1.39 2.13-2.59 2.71-1.22.59-2.87.88-4.91.88-1.05 0-2.19-.09-3.38-.28l-.45-.07v5.47l.31.07c1.28.26 2.78.4 4.46.4 3.15 0 5.74-.48 7.71-1.44 2-.97 3.5-2.48 4.46-4.51.95-2 1.43-4.6 1.43-7.74V8.4h.02ZM134.47 44.54c-1.85 0-3.26-.53-4.22-1.59s-1.45-2.63-1.45-4.68v-12.6h6.63c4.84 0 4.84-5.29 4.84-5.29H128.8v-7.14h-6.07v7.14h-5.67v5.29h5.67v13.7c0 3.39.91 6.04 2.7 7.87s4.42 2.76 7.81 2.76c2.1 0 4.23-.28 6.33-.83l.3-.08v-5.45l-.5.15c-1.66.49-3.31.74-4.9.74ZM115.11 36.78v-.39c0-2.59-.48-5.03-1.43-7.25-1.26-2.88-3.43-5.15-6.44-6.74-2.99-1.58-6.7-2.38-11.02-2.38s-8 .77-11.04 2.29c-3.07 1.54-5.26 3.76-6.53 6.61-.84 1.92-1.26 3.98-1.26 6.12s.41 4.17 1.21 5.9c1.26 2.89 3.49 5.15 6.61 6.72 3.1 1.56 6.92 2.35 11.35 2.35 3.07 0 5.9-.36 8.41-1.08 2.52-.73 4.67-1.89 6.38-3.46 1.88-1.7 3.1-3.83 3.64-6.34l.1-.48h-6.16l-.07.3a6.106 6.106 0 0 1-1.89 3.17c-1.11.97-2.56 1.72-4.32 2.22-1.78.51-3.77.77-5.93.77-3.13 0-5.82-.51-7.99-1.51-2.14-.99-3.63-2.41-4.44-4.22-.37-.8-.62-1.67-.75-2.59-.29-2.59.23-4.67.23-4.67.17-.61.32-1.07.46-1.35.85-1.89 2.3-3.34 4.31-4.31 2.04-.98 4.63-1.48 7.68-1.48s5.62.49 7.74 1.46c2.08.95 3.55 2.35 4.35 4.15.22.52.4 1.03.53 1.53H90.22c-4.44 0-4.44 4.67-4.44 4.67h29.33Z",
        class: "svg-VF-logo_svg__cls-1"
      }),
      _createElementVNode("path", {
        d: "M45.99 11.83c0-3.75-2.82-6.89-3.73-7.81C41.35 3.09 38.27 0 38.27 0v33.36c0 3.75 2.82 6.89 3.73 7.81.91.93 3.99 4.02 3.99 4.02V11.83ZM32.61 16.48c2.66-2.65 2.89-6.86 2.9-8.15 0-1.3.03-5.66.03-5.66L2.93 35.19C.28 37.84.04 42.05.03 43.34.03 44.64 0 49 0 49l32.61-32.52Z",
        class: "svg-VF-logo_svg__cls-2"
      }),
      _createElementVNode("path", {
        d: "M32.61 16.48c2.66-2.65 2.89-6.86 2.9-8.15 0-1.3.03-5.66.03-5.66L2.93 35.19C.28 37.84.04 42.05.03 43.34.03 44.64 0 49 0 49l32.61-32.52ZM32.15 46.12c2.66 2.65 6.88 2.88 8.18 2.89s5.67.03 5.67.03L33.2 36.27c-2.66-2.65-6.87-2.88-8.18-2.9-1.3 0-5.67-.03-5.67-.03l12.8 12.77Z",
        class: "svg-VF-logo_svg__cls-2"
      })
    ], -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "VF-logo"}) } }